function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export default memoize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
// module id = 802
// module chunks = 0